import { Plus, Trash } from 'lucide-react';
import { Button, ButtonIcon, DefaultTable, DefaultTooltip, Input } from 'twyne-new.ui';

import { DefaultDragFormatter, DndSortableList, useSortableDndListItem } from '@/components/SortableDnd';

const getInputType = type => {
  if (type === 'integer') return 'number';
  if (type === 'date') return 'date';
  return 'text';
}

const SortableRow = ({ children, row, className }) => {
  const dnd = useSortableDndListItem(row.id)
  return <tr ref={dnd.setNodeRef} style={dnd.style} className={className}>
    {children}
  </tr>
}

const ConditionalSortableRow = ({ children, row, className }) => {
  if (row.isSkip) return <tr className={className}>{children}</tr>
  return <SortableRow row={row} className={className}>{children}</SortableRow>
}

export default function AnswerTab({ answers, disabled, customField, onChange, onAddAnswer, skipOption, skipAnswer, onChangeSkipAnswer }) {
  const keysDisabled = customField.type === 'select' || customField.type === 'boolean'
  const inputType = getInputType(customField.type)
  const regularData = (answers || []).map((answer, index) => ({ ...answer, id: index }))
  const skipData = skipOption && skipAnswer ? [{ ...skipAnswer, id: 'skip', isSkip: true }] : []
  const data = [...regularData, ...skipData]

  const handleChange = (index, key, value) => {
    if (customField.type === 'input') {
      value = value.replace(/[}{,()$]/g, '')
    }
    answers[index][key] = value
    onChange([...answers])
  }

  const handleDelete = index => {
    answers.splice(index, 1)
    onChange([...answers])
  }

  const columns = [
    {
      dataField: '',
      text: '',
      className: 'w-8',
      formatter: (_, row) => row.isSkip ? null : <DefaultDragFormatter row={row} />,
    },
    {
      dataField: 'key',
      text: 'Key',
      formatter: (value, row) => <Input
        type={inputType}
        disabled={keysDisabled || row.isSkip || value === '$skip'}
        value={value}
        onChange={e => !row.isSkip && handleChange(row.id, 'key', e.target.value)}
        placeholder="Key"
      />,
    },
    {
      dataField: 'answer',
      text: 'Answer',
      formatter: (value, row) => <Input
        value={value}
        disabled={disabled}
        onChange={e => row.isSkip
          ? onChangeSkipAnswer?.('answer', e.target.value)
          : handleChange(row.id, 'answer', e.target.value)
        }
        placeholder="Answer"
      />,
    },
    ...!keysDisabled ? [{
      dataField: '',
      text: '',
      className: 'w-8',
      formatter: (_, row) => row.isSkip ? null : <ButtonIcon content='Delete' onClick={() => handleDelete(row.id)} disabled={disabled}>
        <Trash size={16} />
      </ButtonIcon>,
    }] : [],
  ]

  return <>
    <div className='flex justify-end'>
      <DefaultTooltip content={!['integer', 'input', 'date'].includes(customField.type) && 'Custom fields needs to be of type integer, input, or date to add answers.'}>
        <Button
          color="accent"
          size="sm"
          onClick={() => onAddAnswer({})}
          disabled={disabled || !['integer', 'input', 'date'].includes(customField.type)}
        >
          <Plus size={16} />
          Add
        </Button>
      </DefaultTooltip>
    </div>
    <DndSortableList items={regularData} onSortEnd={onChange}>
      <DefaultTable
        data={data}
        columns={columns}
        rowWrapper={ConditionalSortableRow}
        noDataIndication={() => 'No answers to show.'}
        className='max-h-[30vh] overflow-y-auto'
      />
    </DndSortableList>
  </>
}
